import BedSvg from '@assets/images/svg/bed.svg';
import React from 'react';
import { View } from 'react-native';

export interface BedIconProps {
    size?: number;
    color?: string;
}

export function BedIcon({ size = 24, color = '#333333' }: BedIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BedSvg width={size} height={size} color={color} />
        </View>
    );
}

export default BedIcon;
